import React, { useEffect } from "react";
import CodePreneursTemplate from "../../Templetes/CodePreneurs/CodePreneurs.template";

const CodePreneursPage = () => {
  useEffect(() => {
    document.title = "Code Challenge - CodePreneurs";
  }, []);
  return <CodePreneursTemplate />;
};

export default CodePreneursPage;

